import { useUnreadCountSelector } from "domains/concierge/internal/hooks/useUnreadCountSelector";

export const useUserUnreadCount = () => {
    return useUnreadCountSelector(
        (state) => state.conversations.unreadCounts.ticket.user,
    );
};
